import type { Exam, ExamState } from '../../exam.js';
import { runStructureConfirmationAgent } from '../agents/confirm-in-chat-agent.js';

export const confirmStructureInChatToolDef = [
  {
    type: 'function',
    function: {
      name: 'confirm_structure_in_chat',
      description:
        'Rufe dieses Tool sofort und automatisch auf, wenn du den User gefragt hast, ob die erkannte Aufgabenstruktur passt, und der User sie im Chat bestätigt. Die Bestätigungsnachricht ist jetzt nur eine kurze Zusammenfassung; die eigentliche Bearbeitung findet im Struktur-Canvas statt. Rufe das Tool also immer auf, nachdem der User mit zum Beispiel "ja", "passt", "ist ok" oder "bestätige" reagiert. Das Tool führt die Bestätigung der Aufgabenstruktur durch und ist notwendig damit die Extraktion fortgeführt werden kann.',
      parameters: {
        type: 'object',
        properties: {
          confirmed: { type: 'boolean', description: 'Ob die Struktur bestätigt wurde' },
        },
        required: ['confirmed'],
      },
    },
  },
];

export async function handleConfirmStructureInChat(exam: Exam, toolCallArgs: any): Promise<object> {
  let toolResultContent = '';
  toolResultContent = await runStructureConfirmationAgent(
    Boolean(toolCallArgs.confirmed),
    exam._id,
    exam.conversationId,
  );
  return { content: toolResultContent };
}

export function confirmStructureInChatAvailability(_examState: ExamState): boolean {
  return true;
}
